<template lang="pug">
el-collapse(v-model="membroId")
    el-collapse-item(
      v-for="(membro, index) in membros"
      :key="index"
      :title="membro.nome",
      :name="index",
    )
      el-row
        el-col(:span="12")
          app-display(
            label="Nome:",
            :content="membro.nome"
        )
        el-col(:span="12")
          app-display(
            label="Data de Nascimento:",
            :content="formatDate(membro.dataNascimento, 'DD/MM/YYYY')"
          )
      el-row
        el-col(:span="12")
          app-display(
            label="Sexo:",
            :content="formataTexto(membro.sexo)"
          )
        el-col(:span="12")
          app-display(
            label="Estado civil:",
            :content="formatarEstadoCivil(membro.estadoCivil)"
          )
      el-row
        el-col(:span="12")
          app-display(
            label="Profissão:",
            :content="valorCampo(membro.profissao)"
          )
        el-col(:span="12" v-if="membro.renda")
          app-display(
            label="Renda:",
            :content="exibirValor(membro.renda, 'renda')"
          )
        el-col(:span="12" v-if="membro.rendaMembro")
          app-display(
            label="Renda:",
            :content="formatRenda(membro.rendaMembro)"
          )
      el-row
        el-col(:span="12", v-if="membro.tempoMoradia")
            app-display(
              label="Tempo moradia:",
              :content="valorCampo(membro.tempoMoradia)"
            )
        el-col(:span="12")
          app-display(
            label="Programa Social:",
            :content="valorCampo(membro.programaSocial)"
          )
        el-col(:span="12")
          app-display(
            label="Observações referentes à renda:",
            :content="valorCampo(membro.observacoesRenda)"
          )
</template>

<script>
import AppDisplay from './AppDisplay'
import format from '../utils/utils'
import utils from '@/utils/utils'
import { estadoCivil } from '@/utils/select-objects'
import enumImovelReurb from '@/utils/enumDadosImovelMobile'

export default {

  components: {
    AppDisplay
  },

  mixins: [
    enumImovelReurb
  ],

  props: {
    membros: {
      type: Array,
      required: false,
      default: () => []
    },
    appMembroFamiliaComparar: {
      required: true
    }
  },

  data () {
    return {
      membroId: ''
    }
  },

  methods: {
    formatDate (data, formato) {
      return format.formatDate(data, formato)
    },
    formataTexto (texto) {
      texto = this.valorCampo(texto)
      let formatText = texto.toLowerCase()
      return formatText[0].toUpperCase() + formatText.slice(1)
    },
    formatarEstadoCivil (estadoCivilMembro) {
      const estado = estadoCivil.find(value => value.codigo === estadoCivilMembro)
      return estado.name
    },
    formatRenda (valor) {
      return utils.padraoMoedaBrasil.format(valor)
    },

    exibirValor (value, campo) {
      if (value) {
        return enumImovelReurb[campo][value]
      }
      return ' - '
    },
    valorCampo (valor) {
      return valor || '-'
    }
  }

}
</script>
<style lang="scss" scoped>
>>> .text .text{
    color: #ff0000 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/AppMembroFamiliaComparar.vue